import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/wiki',
        name: 'wiki',
        component: () => import('@/views/Wiki/Index.vue'),
        meta: {
            title: 'wiki.pageTitle',
            menuRendered: true,
            menuTitle: 'wiki.menuTitle',
            requiresAuth: true,
            permission: 'wiki_read',
            icon: 'mdi-wikipedia'
        }
    }
]

export default routes
